// removed by extract-text-webpack-plugin
module.exports = {"button":"CalendarHourButton__button__2Eem6","clockIcon":"CalendarHourButton__clockIcon__11xqF","hour":"CalendarHourButton__hour__3_b7w","active":"CalendarHourButton__active__gWI37"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/UI/CalendarHourButton/CalendarHourButton.css
// module id = 465
// module chunks = 0